import { useEffect } from 'react';

interface Props {
    setIsRunning: (state: boolean) => void;
    isRunning: boolean;
    stopTime: number;
    reset?: boolean;
    time: number;
    setTime: (time: number) => void;
}

const StopWatch = ({
    setIsRunning,
    isRunning,
    stopTime,
    reset,
    time,
    setTime,
}: Props) => {
    //const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let intervalId: number;
        if (isRunning) {
            intervalId = window.setInterval(() => setTime(time + 1), 10);

            if (stopTime && (time % 6000) / 100 === stopTime) {
                setIsRunning(false);
            }
        }
        return () => clearInterval(intervalId);
    }, [isRunning, time]);

    const seconds = time > 0 ? Math.floor((time % 6000) / 100) : 0;

    // Milliseconds calculation
    const milliseconds = time > 0 ? time % 100 : 0;

    useEffect(() => {
        if (reset) {
            setTime(0);
        }
    }, [reset]);

    return (
        <div>
            <p className="text-sm w-fit text-[var(--primary-text-color)] font-bold tracking-widest">
                {seconds.toString().padStart(2, '0')}:
                {milliseconds.toString().padStart(2, '0')}
            </p>
        </div>
    );
};

export default StopWatch;
